import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import PropertiesActions from 'app/shared/actions/PropertiesActions';

import PropertyPanelModel from 'app/shared/model/PropertyPanel';

import InteractiveCard from 'app/shared/components/InteractiveCard';
import LayoutWithSubTitle from './components/LayoutWithSubTitle';
import LayoutWithoutSubTitle from './components/LayoutWithoutSubTitle';

import {
    StyledLink,
} from './StyledComponents';

const PANEL_ID = {
    ANALYTICS: 'analytics',
    APPLICATIONS: 'applications',
    FIND_TENANTS: 'findTenants',
    LEASES: 'leases',
    MANAGE_TENANTS: 'manageTenants',
    MESSAGES: 'messages',
    PAYMENTS: 'payments',
    REVIEWS: 'reviews',
};

const escapeRoute = (id) => {
    switch (id) {
        // within rmw
        case PANEL_ID.ANALYTICS:
        case PANEL_ID.FIND_TENANTS:
        case PANEL_ID.MANAGE_TENANTS:
        case PANEL_ID.REVIEWS:
            return false;

        // outside of rmw
        // fall through
        case PANEL_ID.APPLICATIONS:
        case PANEL_ID.LEASES:
        case PANEL_ID.PAYMENTS:
        case PANEL_ID.MESSAGES:
        default:
            return true;
    }
};

const PropertyPanel = ({
    isConnectedExperience,
    listingAlias: propertyId,
    panelModel,
}) => {
    const dispatch = useDispatch();

    const {
        id,
        isDisabled,
        urlPath,
    } = panelModel;

    return (
        <div className="PropertyPanel">
            {isDisabled ? (
                <InteractiveCard isDisabled={isDisabled}>
                    {isConnectedExperience
                        ? <LayoutWithSubTitle panelModel={panelModel} />
                        : <LayoutWithoutSubTitle panelModel={panelModel} />
                    }
                </InteractiveCard>
            ) : (
                <StyledLink
                    to={urlPath}
                    disabled={isDisabled}
                    onClick={(event) => {
                        event.preventDefault();

                        // update on route change: fixes incorrect connected access
                        // FIND: update listing isConnectedExperience
                        dispatch(PropertiesActions.getIsConnectedExperience(propertyId)).finally(() => {
                            // some routes need to be escaped as they are served on a different server
                            if (escapeRoute(id)) {
                                window.router.updateLocation(urlPath);
                            } else {
                                window.router.transitionTo(urlPath);
                            }
                        });
                    }}
                >
                    <InteractiveCard isDisabled={isDisabled}>
                        {isConnectedExperience
                            ? <LayoutWithSubTitle panelModel={panelModel} />
                            : <LayoutWithoutSubTitle panelModel={panelModel} />
                        }
                    </InteractiveCard>
                </StyledLink>
            )}
        </div>
    );
};

PropertyPanel.propTypes = {
    isConnectedExperience: PropTypes.bool.isRequired,
    listingAlias: PropTypes.string.isRequired,
    panelModel: PropTypes.shape({
        isDisabled: PropTypes.bool.isRequired,
        message: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
        title: PropTypes.string.isRequired,
        urlPath: PropTypes.string.isRequired,
    }),
};

PropertyPanel.defaultProps = {
    panelModel: PropertyPanelModel({}),
};

export default PropertyPanel;
